import React from "react";
import {
  FaParking,
  FaDog,
  FaTv,
  FaHandsWash,
  FaPlaneDeparture,
  FaDumbbell,
} from "react-icons/fa";

const HotelOverview = () => {
  const highlights = [
    {
      icon: <FaParking className="text-3xl text-blue-600" />,
      label: "Free parking",
    },
    {
      icon: <FaDog className="text-3xl text-blue-600" />,
      label: "Pets allowed",
    },
    { icon: <FaTv className="text-3xl text-blue-600" />, label: "Cable TV" },
    {
      icon: <FaHandsWash className="text-3xl text-blue-600" />,
      label: "Washing machine",
    },
    {
      icon: <FaPlaneDeparture className="text-3xl text-blue-600" />,
      label: "Airport lift",
    },
    {
      icon: <FaDumbbell className="text-3xl text-blue-600" />,
      label: "Fitness center",
    },
  ];

  return (
    <>
      {/* Overview Section */}
      <div className="mx-auto mb-8 mt-8 max-w-screen-2xl rounded-xl bg-white p-6 shadow">
        <h3 className="mb-2 text-lg font-bold text-gray-800">Overview</h3>
        <p className="text-md text-gray-800">
          Located in Taksim Gmsuyu, the heart of Istanbul, the CVK Park
          Bosphorus Hotel Istanbul has risen from the ashes of the historic Park
          Hotel, which also served as Foreign Affairs Palace 120 years ago and
          is hosting its guests by assuming this hospitality mission. With its
          452 luxurious rooms and suites, 8500 m² SPA and fitness area, 18
          meeting rooms including 4 dividable ones and 3 terraces with Bosphorus
          view, Istanbul’s largest terrace with Bosphorus view (4500 m²) and
          latest technology infrastructure, CVK Park Bosphorus Hotel Istanbul is
          destined to be the popular attraction point of the city. Room and
          suite categories at various sizes with city and Bosphorus view, as
          well as 68 separate luxury suites, are offered to its special guests
          as a wide variety of selection.
        </p>
      </div>

      {/* Highlights Section */}
      <div className="mx-auto mb-8 max-w-screen-2xl rounded-xl bg-white p-6 shadow">
        <h3 className="mb-4 text-lg font-bold text-gray-800">Highlights</h3>
        <div className="overflow-x-auto">
          <div className="flex min-w-[600px] gap-4 text-center sm:grid sm:grid-cols-3 md:grid-cols-6">
            {highlights.map((item, index) => (
              <div
                key={index}
                className="flex min-w-[100px] flex-col items-center gap-2 border-l border-blue-600 first:border-l-0"
              >
                {item.icon}
                <p className="text-sm text-gray-700">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default HotelOverview;
